import { ColorField } from './ColorField';
import type { Palette } from '../ColorPicker/ColorPicker';
import { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';
import type { Color, Gradient, RGBA } from '@builder4/shared/types/layout';
import { checkIsGradient, rgbaToHexa } from '@builder4/shared/utils/styleHelpers';

type Props = {
  text?: string;
  className?: string;
  value?: Color | null;
  palettes?: Palette[];
  onChange?: (value: Color | string | null | undefined) => void;
  onChangeComplete?: (value: Color | string | null, initialValue: Color | string) => void;
};

const StylesBgColorSettings = ({
  text = 'Fill',
  className = 'max-w-[216px]',
  value,
  palettes,
  onChange,
  onChangeComplete,
}: Props) => {
  const isGradient = value ? checkIsGradient(value) : false;
  const gradientValue = isGradient ? (value as Gradient) : undefined;

  const getColorHexForInput = (color: Color | null | undefined): string => {
    if (!color) return '';
    if (checkIsGradient(color)) return ''; // Gradients don't have a single hex representation
    return rgbaToHexa(color as RGBA);
  };

  const [colorHex, setColorHex] = useState(getColorHexForInput(value));

  useEffect(() => {
    setColorHex(getColorHexForInput(value));
  }, [value]);

  return (
    <ColorField
      hasGradient={true}
      canClear={true}
      className={cn(className)}
      inputValue={colorHex}
      placeholderText="-"
      state="default"
      text={text}
      type="text"
      color={isGradient ? undefined : value || undefined}
      gradient={gradientValue}
      mode={isGradient ? 'gradient' : 'solid'}
      palettes={palettes}
      onChange={(color) => {
        onChange?.(color ?? null);
      }}
      onChangeComplete={(color, initialValue) => {
        onChange?.(color ?? null);
        onChangeComplete?.(color, initialValue);
      }}
    />
  );
};
export default StylesBgColorSettings;
